/**
 * Single source of truth for Consulting service landing pages.
 * Used by RelatedServices to render cross-navigation between them.
 */
export const SERVICES = [
  {
    slug: "math-stem-tutoring",
    n: "01",
    title: "Mathematics & STEM Tutoring",
    tagline: "Personalized tutoring that builds mathematical thinking, not memorization.",
    href: "/consulting/math-stem-tutoring",
  },
  {
    slug: "youth-mentorship-guidance",
    n: "02",
    title: "Youth Mentorship & Guidance",
    tagline: "One-to-one mentorship in faith, character, and purpose for young men.",
    href: "/consulting/youth-mentorship-guidance",
  },
  {
    slug: "career-counselling",
    n: "05",
    title: "Career Counselling",
    tagline: "Preparing secondary students for university, trades, service, and work.",
    href: "/consulting/career-counselling",
  },
];
